import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Fc2Slice } from '../app-state';
import { getTraceabilityDetails } from '../shared/traceability';
import { selectSelectedPipelineRunForPipeline } from '../pipeline-run/pipeline-run.selectors';
import { selectJiraUiBaseUrl } from '../environment/environment.selectors';

// First selector should be a featureSelector
export const selectFc2Slice = createFeatureSelector<Fc2Slice>('fc2Slice');

export const selectDeliveryRequirements = createSelector(selectFc2Slice, (fc2Slice) => {
  return fc2Slice.deliveryRequirements;
});

export const selectDeliveryRequirementsTestcases = createSelector(selectFc2Slice, (fc2Slice) => {
  return fc2Slice.deliveryTestcases;
});

export const selectPipelineRunRequirements = (pipelineRunId: number) =>
  createSelector(selectFc2Slice, (fc2Slice) => {
    return fc2Slice.pipelineRunRequirements[pipelineRunId];
  });

export const selectPipelineRunRequirementsByPipeline = (pipelineId: string) =>
  createSelector(selectSelectedPipelineRunForPipeline(pipelineId), selectFc2Slice, (selectedPipelineRunId, fc2Slice) => {
    return fc2Slice.pipelineRunRequirements[selectedPipelineRunId];
  });

export const selectPipelineRunRequirementsTestcases = (pipelineRunId: number) =>
  createSelector(selectFc2Slice, (fc2Slice) => {
    return fc2Slice.pipelineRunRequirementsTestcases[pipelineRunId];
  });

export const selectDeliveryTraceabilityDetails = createSelector(
  selectDeliveryRequirements,
  selectDeliveryRequirementsTestcases,
  selectJiraUiBaseUrl,
  (deliveryRequirements, deliveryTestcases, jiraUiBaseUrl) => {
    return getTraceabilityDetails(deliveryRequirements, deliveryTestcases, jiraUiBaseUrl);
  },
);

export const selectPipelineRunTraceabilityDetails = (pipelineId: string) => {
  return createSelector(
    selectSelectedPipelineRunForPipeline(pipelineId),
    selectDeliveryRequirements,
    selectFc2Slice,
    selectJiraUiBaseUrl,
    (selectedPipelineRunId, deliveryRequirements, fc2Slice, jiraUiBaseUrl) => {
      const pipelineRunTestcases = fc2Slice.pipelineRunRequirementsTestcases[selectedPipelineRunId];
      return getTraceabilityDetails(deliveryRequirements, pipelineRunTestcases, jiraUiBaseUrl).filter(
        (requirementDetail) => requirementDetail.testStatus !== 'No tests',
      );
    },
  );
};
